import { createFileRoute, Outlet, useLocation, useNavigate } from "@tanstack/react-router"
import { useAuth } from "hooks/use-auth"
import { useUserType } from "hooks/use-user-type"
import { useEffect } from "react"
import { Page } from "@/components/page"
import { Typography } from "@/components/ui/typography"
import { useEmergencyContacts } from "@/hooks/use-emergency-contact-ids"
import { hasSkippedEmergencyContactsThisSession } from "@/lib/emergency-contact-onboarding"

export const Route = createFileRoute("/_authed/_individual")({
  component: IndividualLayout,
})

function IndividualLayout() {
  const { isAuthenticated, isLoading } = useAuth()
  const { isIndividual } = useUserType()
  const { emergencyContacts, isLoading: isLoadingContacts } = useEmergencyContacts()
  const navigate = useNavigate()
  const pathname = useLocation({ select: (location) => location.pathname })

  useEffect(() => {
    if (!isLoading && isAuthenticated && !isIndividual) {
      navigate({
        to: "/professional/clients",
        replace: true,
      })
    }
  }, [isAuthenticated, isLoading, isIndividual, navigate])

  useEffect(() => {
    if (!isLoading && !isLoadingContacts && isAuthenticated && isIndividual) {
      const hasNoEmergencyContacts = emergencyContacts.length === 0
      const isOnboardingRoute = pathname.startsWith("/onboarding")
      const skippedThisSession = hasSkippedEmergencyContactsThisSession()

      if (hasNoEmergencyContacts && !isOnboardingRoute && !skippedThisSession) {
        navigate({
          to: "/onboarding/emergency-contacts",
          replace: true,
        })
      }
    }
  }, [
    emergencyContacts.length,
    isAuthenticated,
    isIndividual,
    isLoading,
    isLoadingContacts,
    navigate,
    pathname,
  ])

  if (isLoading) {
    return (
      <Page>
        <Typography as="h1" size="2xl">
          Loading...
        </Typography>
      </Page>
    )
  }

  if (!isAuthenticated || !isIndividual) {
    return null // Will redirect in useEffect
  }

  return <Outlet />
}
